import { formatDate } from '@koob/dates';
import { ExtraScopeEnum } from '@koob/enums';
import { decodeId } from '../../../../utils';

// What the two save calls send, built from the trip as the composer holds it.

const toDayOption = extra => ({
  extraId: extra.id,
  parentExtraId:
    typeof extra.parentExtraId === 'object'
      ? extra.parentExtraId.id
      : (extra.parentExtraId ?? undefined),
  // KD-3650 — one line per occurrence: the key and the rank are
  // what tells them apart once the trip is read back.
  occurrenceKey: extra.occurrenceKey ?? undefined,
  rank: extra.rank ?? undefined,
  parentOccurrenceKey: extra.parentOccurrenceKey ?? undefined,
  adultCount: extra.adultCount ?? extra.adults ?? undefined,
  childrenBirthdates: extra.childrenBirthdates ?? undefined,
});

const toGlobalOption = (extra, dayIdx) => ({
  dayIndex: dayIdx + 1,
  extraId: extra.id,
  parentExtraId: extra.parentExtraId ?? undefined,
  occurrenceKey: extra.occurrenceKey ?? undefined,
  rank: extra.rank ?? undefined,
  parentOccurrenceKey: extra.parentOccurrenceKey ?? undefined,
  adultCount: extra.adultCount ?? extra.adults ?? undefined,
  childrenBirthdates: extra.childrenBirthdates ?? undefined,
});

const extrasOf = day =>
  Array.isArray(day?.selectedExtras) ? day.selectedExtras : [];

export const toTripDaysPayload = days =>
  days?.map((day, index) => ({
    dayIndex: index + 1,
    experienceId: day?.experienceId ?? undefined,
    hotelId: day?.hotelId ? '' + decodeId(day.hotelId) : undefined,
    hotelBookedOnMyOwn: day?.hotelBookedOnMyOwn ?? false,
    hotelSelectedRoomKey: day?.selectedRoom?.roomKey ?? undefined,
    roomsComposition: day?.roomsComposition ?? null,
    skipTransitionOption: day?.skipTransitionOption ?? false,
    options: extrasOf(day)
      .filter(extra => extra.scope === ExtraScopeEnum.DAY)
      .map(toDayOption),
  })) ?? [];

export const toGlobalOptionsPayload = days =>
  days?.flatMap((d, dayIdx) =>
    extrasOf(d)
      .filter(extra => extra.scope === ExtraScopeEnum.GLOBAL)
      .map(extra => toGlobalOption(extra, dayIdx)),
  ) ?? [];

export const toTravelersPayload = tripFilters => ({
  adultPax: tripFilters?.composition?.adults,
  childrenBirthdates: tripFilters?.composition.childrenBirthdates.map(item =>
    formatDate(item, 'YYYY-MM-DD'),
  ),
});

// Trip saved with the updated values first (date, duration, composition).
export const toTripPayload = (trip, tripFilters) => ({
  ...trip,
  dmcId: trip?.dmc?.id,
  startDate: tripFilters?.departureDate,
  duration: tripFilters?.tripDuration,
  adultPax: tripFilters?.composition?.adults,
  locale: tripFilters?.locale,
  childrenBirthdates: tripFilters?.composition?.childrenBirthdates?.map(item =>
    formatDate(item, 'YYYY-MM-DD'),
  ),
  // Keep the wizard's brief/themes/styles — replacing tripFilters with only
  // composition wiped them, so reopening a draft lost the brief and filters.
  tripFilters: {
    ...trip?.tripFilters,
    brief: tripFilters?.brief ?? trip?.tripFilters?.brief,
    themes: tripFilters?.themes ?? trip?.tripFilters?.themes,
    styles: tripFilters?.styles ?? trip?.tripFilters?.styles,
    composition: tripFilters?.composition,
  },
});
